import { render, staticRenderFns } from "./WebInputs.vue?vue&type=template&id=4fda159e"
import script from "./WebInputs.vue?vue&type=script&lang=js"
export * from "./WebInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports